import axios from "@/axios";
import { AxiosResponse } from "axios";
import {
  AdunitGroupResponse,
  AdunitGroupsResponse,
  EditAdunitGroupResponse,
  AdunitGroupCreateRequest,
  AdunitGroupUpdateRequest,
} from "@/features/adunitGroup/types";

/**
 * Get adunitGroupList.
 */
export function getAdunitGroups(): Promise<AxiosResponse<AdunitGroupsResponse>> {
  return axios.get<AdunitGroupsResponse>(`/adunit-groups/`);
}
/**
 * Get adunitGroup by adunitGroupId.
 */
export function getAdunitGroupById(
  adunitGroupId: number
): Promise<AxiosResponse<AdunitGroupResponse>> {
  return axios.get<AdunitGroupResponse>(`/adunit-groups/${adunitGroupId}/`);
}
/**
 * Create a adunitGroup.
 * @param createArg
 */
export function createAdunitGroup(
  createArg: AdunitGroupCreateRequest
): Promise<AxiosResponse<EditAdunitGroupResponse>> {
  return axios.post<EditAdunitGroupResponse>(`/adunit-groups/`, {
    adunitGroupName: createArg.adunitGroupName,
    adunits: createArg.adunits,
    publisherId: createArg.publisherId,
  });
}
/**
 * Update a adunitGroup.
 * @param createArg
 */
export function updateAdunitGroup(
  updateArg: AdunitGroupUpdateRequest
): Promise<AxiosResponse<EditAdunitGroupResponse>> {
  return axios.put<EditAdunitGroupResponse>(`/adunit-groups/${updateArg.adunitGroupId}/`, {
    adunitGroupName: updateArg.adunitGroupName,
    adunits: updateArg.adunits,
    publisherId: updateArg.publisherId,
  });
}
/**
 * Delete adunitGroup by adunitGroupId.
 * @param adunitGroupId
 */
export function deleteAdunitGroup(adunitGroupId: number): Promise<AxiosResponse<void>> {
  return axios.delete<void>(`/adunit-groups/${adunitGroupId}/`);
}
